type BrowserStorage = Pick<Window, 'sessionStorage' | 'localStorage'>;
export interface FptProfile { hotel_id?: string; name?: string; hotel_name?: string; establishment_count?: number; [key: string]: unknown }
const key = 'fpt_session';
const asProfile = (value: unknown): FptProfile => value !== null && typeof value === 'object' && !Array.isArray(value) ? value as FptProfile : {};

function readSession(browser: BrowserStorage) {
  const stored = browser.sessionStorage.getItem(key);
  if (stored !== null) {
    try {
      const value = JSON.parse(stored);
      return { token: typeof value?.token === 'string' ? value.token : '', profile: asProfile(value?.profile) };
    } catch { return { token: '', profile: {} as FptProfile }; }
  }
  let profile: FptProfile = {};
  try { profile = asProfile(JSON.parse(browser.localStorage.getItem('user_profile') || '{}')); } catch { /* invalid legacy profile */ }
  return { token: browser.localStorage.getItem('auth_token') || '', profile };
}

export const getAuthToken = (browser: BrowserStorage = window): string => readSession(browser).token;
export const getStoredProfile = (browser: BrowserStorage = window): FptProfile => readSession(browser).profile;

export function storeAuthSession(token: string, profile: FptProfile, browser: BrowserStorage = window): void {
  if (!token || typeof token !== 'string') throw new Error('Session de connexion invalide.');
  browser.sessionStorage.setItem(key, JSON.stringify({ token, profile }));
}

export function clearAuthSession(browser: BrowserStorage = window): void {
  // Prevent a logged-out tab from reviving a legacy session, without affecting other tabs.
  browser.sessionStorage.setItem(key, '');
}
